import { render, staticRenderFns } from "./Poultry.vue?vue&type=template&id=ed0af9a6&scoped=true&"
import script from "./Poultry.vue?vue&type=script&lang=js&"
export * from "./Poultry.vue?vue&type=script&lang=js&"
import style0 from "./Poultry.vue?vue&type=style&index=0&id=ed0af9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0af9a6",
  null
  
)

export default component.exports